module.exports = __webpack_public_path__ + "fr.svg?4e3ec048e64c77815332dbb34f9b6305";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/fr.svg
// module id = 1358
// module chunks = 0